import { useState } from 'react';
import { api, ApiError } from '../lib/api';
import { saveGuest } from '../lib/guest';
import { navigate } from '../lib/router';
import { Mango } from '../ui/icons';

interface Started { token: string; expiresIn: number; restaurant: { name: string }; session: { id: string; pickupNo: string; tableName: string } }

/** /k/<code>: a customer starts a takeout order from the restaurant's link (pay at pickup). */
export function TakeoutStart({ code }: { code: string }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const start = async () => {
    setBusy(true);
    setErr(null);
    try {
      const r = await api<Started>('POST', '/guest/takeout', { body: { code, name, phone } });
      saveGuest({ token: r.token, expiresAt: Date.now() + r.expiresIn * 1000 - 60_000, sessionId: r.session.id, tableName: r.session.pickupNo, restaurant: r.restaurant.name, kind: 'takeout' });
      navigate('/t', true);
    } catch (e) { setErr((e as ApiError).message); setBusy(false); }
  };
  return (
    <main className="screen" style={{ padding: '28px 20px', gap: 16 }}>
      <div className="brand"><div className="logo"><Mango /></div><span className="display" style={{ fontSize: 22 }}>สั่งกลับบ้าน · Takeout</span></div>
      <section className="ticket">
        <p style={{ margin: 0 }}>สั่งล่วงหน้า แล้วมารับที่ร้าน ชำระเงินตอนรับ · Order ahead, pick up at the restaurant, pay at pickup.</p>
        <label className="field">ชื่อ · Name<input value={name} maxLength={40} onChange={(e) => setName(e.target.value)} autoComplete="name" /></label>
        <label className="field">เบอร์โทร · Phone<input value={phone} inputMode="tel" maxLength={15} onChange={(e) => setPhone(e.target.value)} autoComplete="tel" /></label>
        <button className="cta light" disabled={busy || !name.trim() || phone.replace(/\D/g, '').length < 9} onClick={() => void start()}>ดูเมนู · See the menu</button>
        {err && <div className="warn" role="alert">{err}</div>}
      </section>
    </main>
  );
}
